import type { OptimizationUpdateMessage } from '@/shared/api/socket-messages'
import type { Message } from '@/shared/api/websocket/types'

import Deferred from '@/shared/api/websocket/deferred'
import Observer from '@/shared/api/websocket/observer'

// Optimization update event observer
export const $optimizationUpdate = new Observer()

/**
 * Listen for optimization group status change and wait for it to change to one of the specified statuses
 * @param id - optimization group id to wait for
 * @param statuses - statuses to wait for
 * @returns promise - promise that resolves when optimization group status changes to one of the specified statuses
 */
export function waitGroupStatus(id: string, statuses: string[]) {
	const deferred = new Deferred()
	const handler = (msg: Message<OptimizationUpdateMessage>) => {
		if (statuses.includes(msg.payload.optimization_status)) {
			deferred.resolve(msg.payload.optimization_status)
			$optimizationUpdate.off(`optimization:${id}:update`, handler)
		}
	}
	$optimizationUpdate.on(`optimization:${id}:update`, handler)

	return deferred.promise
}
